export const FILTERS_ACTIONS = {
  APPLY_CURRENT: 'applyCurrent',
  UPDATE_CURRENT: 'updateCurrent',
  CANCEL_CURRENT: 'cancelCurrent',
  SET_MIN_SAMPLE_SIZE: 'setMinSampleSize',
  CLEAR_ALL_PANEL: 'clearAllPanel',
  CLEAR_ALL_PORTAL: 'clearAllPortal',
  RESET: 'reset',
  TOGGLE_FILTERED_ROW_AVERAGES: 'toggleFilteredRowAverages'
} as const

export type FiltersActionsType = (typeof FILTERS_ACTIONS)[keyof typeof FILTERS_ACTIONS]
